/**
 * Feature Flags API.
 */

import { apiFetch } from './core'

export const flags = {
    list: () => apiFetch('/flags/'),
    create: (params) => apiFetch(`/flags/?key=${encodeURIComponent(params.key)}&description=${encodeURIComponent(params.description || '')}`, {
        method: 'POST',
    }),
    update: (key, params) => {
        const qs = Object.entries(params)
            .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
            .join('&')
        return apiFetch(`/flags/${encodeURIComponent(key)}?${qs}`, { method: 'PATCH' })
    },
    delete: (key) => apiFetch(`/flags/${encodeURIComponent(key)}`, { method: 'DELETE' }),
}
